import { Button, List, Space, Tag, Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import React, {useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import numberHelper from '../../../helpers/functions/number.helper';
import {set_purchase_detail} from "../../../actions/purchase.action";

const OrderAddOnList = ({ discount_add_ons }) => {
    const purchaseRedux = useSelector(state => state.purchase);
    const ticketRedux = useSelector(state => state.ticket);
	const dispatch = useDispatch();
    const promotion_code = purchaseRedux?.promotion_code;
    const currency = ticketRedux?.park?.currency?.symbol;

	// useEffect(() => {
	// 	const add_ons = purchaseRedux?.add_ons || [];
	// 	const ticket_users = purchaseRedux?.ticket_users || [];
	//
	// 	// 🧮 Sum all quantities (fallback to 1 if no quantity field)
	// 	const total_ticket_quantity = ticket_users.reduce(
	// 		(sum, user) => sum + (user?.quantity || 1),
	// 		0
	// 	);
	//
	// 	// ✅ Find insurance add-ons
	// 	const hasInsurance = add_ons.some(
	// 		(x) => x?.add_on_section?.is_insurance === true
	// 	);
	//
	// 	if (!hasInsurance) return;
	//
	// 	// 🆕 Update insurance quantities
	// 	const updated_add_ons = add_ons.map((x) =>
	// 		x?.add_on_section?.is_insurance
	// 			? { ...x, quantity: total_ticket_quantity }
	// 			: x
	// 	);
	//
	// 	// ✅ Dispatch only if something truly changed
	// 	const hasChange = JSON.stringify(add_ons) !== JSON.stringify(updated_add_ons);
	// 	if (hasChange) {
	// 		dispatch(set_purchase_detail({ add_ons: updated_add_ons }));
	// 	}
	// }, [
	// 	// Track both length and total quantity
	// 	purchaseRedux.ticket_users?.length,
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// 	JSON.stringify(purchaseRedux.ticket_users?.map((u) => u.quantity)),
	// ]);
	
	return (
        <>
            {
                purchaseRedux?.add_ons?.length > 0 &&
                (
                    <>
                        <div style={{textAlign:'left', paddingInline: 24, marginTop: 12, }}>
                            <span style={{fontWeight:500, fontSize:16, color:'var(--main-color)'}}>Add Ons</span>
                        </div>
                        <div>
                            <List
                            dataSource={purchaseRedux?.add_ons}
                            renderItem={(item, index) => {
                                const { name, price, quantity, add_on_id, add_on_setup_id, minimum_order } = item ?? {};
                                const is_below_moq = minimum_order > 0 && quantity < minimum_order;

                                // check if promotion code apply for this ticket user
                                const discount_add_on = discount_add_ons?.find(x => x.add_on_setup_id === add_on_setup_id);

                                const is_applicable_promotion_code = (promotion_code?.promotion_code_add_ons?.find(x => x.add_on_setup_id === add_on_setup_id));
                                const promotion_price = price - discount_add_on?.discount_amount;
                                const cal_price = is_applicable_promotion_code ? promotion_price : price;
                                const sub_total = cal_price * quantity;
                                return (
                                    <List.Item style={{ paddingInline : 24, }}>
                                        <EntranceMotion initialY={-50} duration={1} style={{width : '100%'}}>
                                            <div style={{fontSize:14, display:'flex', textAlign:'left'}}>
                                                <div>
                                                    <div>
                                                        <span>{item?.name}</span>
                                                    </div>
                                                    <div>
                                                        <Space>
                                                            <div>
                                                                <span className='ticket-label' style={{fontWeight:500, fontSize:14}}>
                                                                    {`${currency}${numberHelper?.commaNumber(sub_total)}`}
                                                                </span>
                                                            </div>
                                                                {
                                                                    is_applicable_promotion_code &&
                                                                    (
                                                                        <>
                                                                            <div>
                                                                                <EntranceMotion>
                                                                                    <span className='ticket-label' style={{fontSize:12, textDecoration: 'line-through', color: 'var(--secondary-text-color)'}}>
                                                                                        {`${currency}${numberHelper?.commaNumber((price * quantity))}`}
                                                                                    </span>
                                                                                </EntranceMotion>
                                                                            </div>
                                                                            <div>
                                                                                <EntranceMotion delay={(0.1)}>
                                                                                    <Tag color='orange' style={{border:'none'}}>
                                                                                        {promotion_code?.promo_code}
                                                                                    </Tag>
                                                                                </EntranceMotion>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }
                                                        </Space>
                                                    </div>
                                                </div>
                                                <div style={{marginLeft:'auto'}}>
                                                    <Space>
                                                        <div>
                                                            <span>
                                                                {quantity}
                                                            </span>
                                                        </div>
                                                        {
                                                            is_below_moq &&
                                                            (
                                                                <Tooltip title={`Minimum order: ${minimum_order}`}>
                                                                    <Tag color='red' icon={<WarningOutlined />} style={{border:'none'}}>
                                                                        {`Min ${minimum_order}`}
                                                                    </Tag>
                                                                </Tooltip>
                                                            )
                                                        }
                                                    </Space>
                                                </div>
                                            
                                            </div>
                                        </EntranceMotion>
                                    </List.Item>
                                )
                            }}
                            />
                        </div>
                    </>
                )
            }
        </>
    );
}

export default OrderAddOnList;